import { prodEnv } from './env.production';
import { stagingEnv } from './env.staging';
import { devEnv } from './env.dev';
import { devLocalEnv } from './env.localhost';

function normaliseUrlToHostname(url: string): string {
  return url.replace('https://', '');
}

export function getEnvVars() {
  // todo should we use static hashes of the domains here to avoid exposing them?
  switch (window.location.hostname) {
    case normaliseUrlToHostname(prodEnv.VITE_PLATFORM_URL):
      return prodEnv;
    case normaliseUrlToHostname(stagingEnv.VITE_PLATFORM_URL):
      return stagingEnv;
    case normaliseUrlToHostname(devEnv.VITE_PLATFORM_URL):
      return devEnv;
    case 'localhost':
      return { ...devEnv, ...devLocalEnv };
    default:
      throw new Error(`Unsupported environment: ${window.location.hostname}`);
  }
}
